import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { initTheme } from "@mashriqain/ui";
import "@fontsource-variable/inter-tight/wght.css";
import "@fontsource-variable/inter/wght.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-sans-arabic/400.css";
import "@fontsource/ibm-plex-sans-arabic/500.css";
import "@mashriqain/ui/styles.css";
import "@mashriqain/ui/panel.css";
import "./app.css";
import { App } from "./App";

// The panel is built for mashriqain.com/devops/ and is also served at the
// root of ops.mashriqain.com, so the router's base is whichever this
// address is under.
const built = import.meta.env.BASE_URL.replace(/\/$/, "");
const basename = built && location.pathname.startsWith(built) ? built : "/";

// Light, dark or the device's choice, on <html> before anything is drawn.
initTheme();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
